export { default, StyledTooltip } from './Tooltip';
export type { TooltipProps } from './Tooltip';
